import { h } from 'preact'
import formatDateInLocalTimezone from '../../utils/dateFormatting'
import UserAvatar from '../../User/UserAvatar'

const ActionByUserCell = (accessor: string) => {
  return (props: any) => {
    const actionByUser = props[accessor]
    if (!actionByUser) {
      return null
    }

    const date = formatDateInLocalTimezone(actionByUser[Object.keys(actionByUser)[0]])
    const user = actionByUser[Object.keys(actionByUser)[1]]

    const { id, username, avatar } = user

    return (
      <div className='overview__table-last-action-by-user'>
        <div className='overview__table-last-action-by-user-date'>{date + ' by '}</div>
        <UserAvatar user={{
          id,
          name: username,
          avatar,
          url: `/member/profile?userid=${id}`
        }} openInNewTab style={{ width: '16px', height: '16px' }} />
        <a href={user.url} target='_blank'>{username}</a>
      </div>
    )
  }
}

export default ActionByUserCell
